import { createAction, props } from '@ngrx/store';

import { InsurancePackage } from '../models/insurance-package.interface';

export const setInsurancePackages = createAction(
  '[Insurance Packages] Set Packages',
  props<{
    insurancePackages: InsurancePackage[];
  }>()
);

export const updateInsurancePackage = createAction(
  '[Insurance Packages] Update Package',
  props<{
    insurancePackage: InsurancePackage;
  }>()
);

export const deleteInsurancePackage = createAction(
  '[Insurance Packages] Delete Package',
  props<{
    id: string;
  }>()
);

export const addInsurancePackage = createAction(
  '[Insurance Packages] Add Package',
  props<{
    insurancePackage: InsurancePackage;
  }>()
);
